import React from 'react';
import { stage as stageEnum } from '../../../../utils';
import { CustomTooltip } from '../../Tooltip/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  tooltip: { padding: theme.spacing(0.5) },
}));

export default function StageDescriptionTooltip({ stage, children }) {
  const classes = useStyles();
  const stageDescription = stageEnum[stage?.name]?.description;

  return (
    <CustomTooltip
      title={
        <Typography variant="subtitle1" className={classes.tooltip}>
          {stageDescription}
        </Typography>
      }
      arrow
      placement="top"
      enterDelay={800}
      enterNextDelay={800}
    >
      {children}
    </CustomTooltip>
  );
}
